<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Device Management">Device Management</a><span
          class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'locationdashboard'" title="Device">Location</router-link><span
          class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">{{ branch_code }}</li>
    </vs-breadcrumb>
    <vs-row>
      <vs-col vs-type="flex" vs-align="center" vs-w="12">
        <h3 style="font-weight: 550">{{ data.branch_name }}</h3>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-align="center" vs-lg="8" vs-sm="12" vs-xs="12">
        <vs-row vs-align="flex-end" vs-type="flex" vs-justify="space-between" vs-w="12">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" style="position: relative" vs-w="6">
            <div style="position: relative; text-align: center; color: white">
              <span style="
                  position: absolute;
                  top: 67%;
                  color: #6c757d;
                  font-family: '7 Segment';
                  left: 44%;
                  transform: translate(-50%, -50%);
                  font-size: 3.5vw;
                ">{{ data_freezer[0].sensordata.temperature.toFixed(0) }}
              </span>

              <img style="width: 100%; height: 100%" src="@/assets/images/rivacold/Display for IOT-01.png" />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" style="position: relative" vs-w="6">
            <div style="position: relative; text-align: center; color: white">
              <span style="
                  position: absolute;
                  top: 67%;
                  color: #6c757d;
                  font-family: '7 Segment';
                  left: 45%;
                  transform: translate(-50%, -50%);
                  font-size: 3.5vw;
                ">
                {{ data_chiller[0].sensordata.temperature.toFixed(0) }}
              </span>

              <img style="width: 100%; height: 100%" src="../../../../assets/images/rivacold/Group 5147.png" />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-card class="container-fluid" style="padding: 2% margin-bottom: 0px; border-radius: 20px;">
            <vs-row>
              <h4 id="text1">Freezer Temperature</h4>
              <vs-spacer />
              <div>
                <ul class="listnone">
                  <li>
                    <p id="text2">Date : {{ date_freezer[0] }}</p>
                  </li>
                  <li>
                    <p id="text3">Time : {{ time_freezer[0] }}</p>
                  </li>
                </ul>
              </div>
            </vs-row>
            <vs-row>
              <ul class="listnone" align="center">
                <li id="text4">
                  {{ data_freezer[0].sensordata.temperature }}°C
                </li>
                <li id="text5">Temperature</li>
              </ul>
              <vs-spacer />
              <div>
                <ul class="listnone" align="center">
                  <li id="text6">{{ data_freezer[0].sensordata.humidity }}%</li>
                  <li id="text7">Humidity</li>
                </ul>
              </div>
            </vs-row>
            <div class="bottom-right-surface-graph">
              <div class="box-chart">
                <p class="avg">avg</p>
                <p>{{ avg_freezer.toFixed(2) }} °C</p>
              </div>
              <div class="box-chart">
                <p class="min">min</p>
                <p>{{ min_freezer.toFixed(2) }} °C</p>
              </div>
              <div class="box-chart">
                <p class="max">max</p>
                <p>{{ max_freezer.toFixed(2) }} °C</p>
              </div>
            </div>
          </vs-card>
          <vs-card class="container-fluid" style="padding: 2% margin-bottom: 0px; border-radius: 20px;">
            <vs-row>
              <h4 id="text1">Chiller Temperature</h4>
              <vs-spacer />
              <div>
                <ul class="listnone">
                  <li>
                    <p id="text2">Date : {{ date_chiller[0] }}</p>
                  </li>
                  <li>
                    <p id="text3">Time : {{ time_chiller[0] }}</p>
                  </li>
                </ul>
              </div>
            </vs-row>
            <vs-row>
              <ul class="listnone" align="center">
                <li id="text4">
                  {{ data_chiller[0].sensordata.temperature }}°C
                </li>
                <li id="text5">Temperature</li>
              </ul>
              <vs-spacer />
              <div>
                <ul class="listnone" align="center">
                  <li id="text6">{{ data_chiller[0].sensordata.humidity }}%</li>
                  <li id="text7">Humidity</li>
                </ul>
              </div>
            </vs-row>
            <div class="bottom-right-surface-graph">
              <div class="box-chart">
                <p class="avg">avg</p>
                <p>{{ avg_chiller.toFixed(2) }} °C</p>
              </div>
              <div class="box-chart">
                <p class="min">min</p>
                <p>{{ min_chiller.toFixed(2) }} °C</p>
              </div>
              <div class="box-chart">
                <p class="max">max</p>
                <p>{{ max_chiller.toFixed(2) }} °C</p>
              </div>
            </div>
          </vs-card>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-lg="7" vs-sm="12" vs-xs="12">
        <vs-card style="border-radius: 15px">
          <vs-row class="mt-2">
            <h4 id="text1">Time Series</h4>
            <vs-spacer />
            <vs-button class="mr-2" radius @click="onExport" color="#333f50" type="flat"
              icon="cloud_download"></vs-button>
            <vs-button radius class="mr-2" color="#333f50" @click="exportToPDF" type="flat"
              icon="picture_as_pdf"></vs-button>
            <vs-button radius class="mr-2" color="#333f50" v-b-modal.modal-1 type="flat" icon="settings"></vs-button>
          </vs-row>
          <vs-row class="mt-2 mb-3">
            <h5 style="color: rgb(126, 126, 126)">{{ arrSensorName }}</h5>
          </vs-row>
          <div ref="pdf" id="app">
            <LineChart :height="400" :chartdata="chart_Data_inside" :options="options_Chart" :heightChart="400" />
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-lg="5" vs-sm="12" vs-xs="12">
        <vs-row>
          <vs-card class="cardBorder">
            <ul class="listS" align="center">
              <li class="mb-3">
                <h4 id="text1">Temperature</h4>
              </li>
              <li>
                <vs-row>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-secondary">
                      <h6 class="ml-2 mr-2">Avg</h6>
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-success">
                      <h6 class="ml-2 mr-2">Min</h6>
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-danger">
                      <h6 class="ml-2 mr-2">Max</h6>
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-2">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ avgValTemp.toFixed(2) }}°C</h3>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ minValTemp.toFixed(2) }}°C</h3>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ maxValTemp.toFixed(2) }}°C</h3>
                  </vs-col>
                </vs-row>
              </li>
            </ul>
          </vs-card>
          <vs-card class="cardBorder">
            <ul class="listS" align="center">
              <li class="mb-3">
                <h4 id="text1">Humidity</h4>
              </li>
              <li>
                <vs-row>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-secondary">
                      <h6 class="ml-2 mr-2">Avg</h6>
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-success">
                      <h6 class="ml-2 mr-2">Min</h6>
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <span class="badge badge-pill badge-danger">
                      <h6 class="ml-2 mr-2">Max</h6>
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-2">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ avgValHumid.toFixed(2) }}%</h3>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ minValHumid.toFixed(2) }}%</h3>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                    <h3>{{ maxValHumid.toFixed(2) }}%</h3>
                  </vs-col>
                </vs-row>
              </li>
            </ul>
          </vs-card>
          <vs-card class="cardBorder"><vs-row class="mt-2 mb-2">
              <h4 id="text1">Temperature Sensor List</h4>
            </vs-row>
            <vs-table :data="data_gateway">
              <template slot="thead">
                <vs-th style="font-size: 0.8rem; white-space: nowrap" v-for="i in header" :key="i">
                  {{ i }}
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td align="center" :data="data[indextr].id">
                    {{ data[indextr].mac }}
                  </vs-td>
                  <vs-td align="center" :data="data[indextr].sensordata.temperature">
                    {{ data[indextr].sensordata.temperature }}°C
                  </vs-td>
                  <vs-td align="center" :data="data[indextr].sensordata.humidity">
                    {{ data[indextr].sensordata.humidity }}%
                  </vs-td>
                  <vs-td align="center" :data="data[indextr].sensordata.battery">
                    {{ data[indextr].sensordata.battery }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card></vs-row>
      </vs-col>
    </vs-row>

    <b-modal id="modal-1" ref="settingChart" hide-header-close centered size="lg">
      <template #modal-title>
        <h4 class="textSuccess">Select Date</h4>
      </template>

      <vs-row>
        <vs-col class="mt-2" vs-lg="4" vs-xs="12">
          <a class="ml-1">Select Sensor</a>
          <vs-select class="mt-1" style="width: 100%" multiple autocomplete v-model="arrSensor">
            <vs-select-item :key="index" :value="item" :text="item.text" v-for="(item, index) in sdata" />
          </vs-select>
        </vs-col> </vs-row><br />
      <vs-row>
        <vs-col class="mt-2" vs-lg="4" vs-xs="12">
          <a class="ml-1">Select Start Date</a>
          <!-- <datetime v-model="mintime" format="YYYY/MM/DD H:i:s" bootstrap-styling = "true" /> -->
          <datetime class="mt-2" v-model="mintime" type="datetime" input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"></datetime>
        </vs-col>
        <vs-col class="mt-2" vs-lg="4" vs-xs="12">
          <a class="ml-1">Select End Date</a>
          <!-- <datetime v-model="maxtime" format="YYYY/MM/DD H:i:s"/> -->
          <datetime class="mt-2" v-model="maxtime" type="datetime" input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"></datetime>
        </vs-col>
      </vs-row>
      <template #modal-footer="{}">
        <vs-button color="success" class="mr-2 btnBorderpop" @click="getChartData()" type="filled">OK</vs-button>
        <vs-button class="btnBorderpop" color="dark" @click="closeModal" type="flat">Cancel</vs-button>
      </template>
    </b-modal>

    <!-- <pre>{{ data }}</pre> -->
    <!-- </vs-card> -->
  </div>
</template>

<script>
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import graph from "./graph.vue";
import SensorChart from "../../Page/IndoorTracking/components/SensorChart";
import SevenSegmentDisplay from "vue-seven-segment-display";
import LineChart from "@/components/ChartJs/LineChart.vue";
import moment from "moment";
export default {
  components: { SevenSegmentDisplay, graph, SensorChart, LineChart },
  props: {},
  data: () => ({
    mintime: "",
    maxtime: "",
    dataExport: [],
    data_sensor: [],
    data_gateway: [],
    data_chiller: [],
    date_chiller: [],
    time_chiller: [],
    data_freezer: [],
    date_freezer: [],
    time_freezer: [],
    chart_Data_inside: {
      datasets: [
        {
          data: [],
          label: "Temperature ( °C )",
          borderWidth: 1.5,
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderColor: "rgba(172, 0, 252,.9)",
          //     backgroundColor:  this.gradient,
        },
        {
          data: [],
          label: "Humid ( % )",
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(20, 153, 242,.9)",

          //     backgroundColor:  this.gradient,
        },
      ],
      labels: [],
    },
    options_Chart: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "bottom",
      },
      scales: {
        yAxes: [
          {
            id: "A",
            ticks: {
              beginAtZero: true,
              // fontColor: "#ffffff",
            },
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "Temp (C) / Humid ()",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              // fontColor: "#ffffff",
            },
            scaleLabel: {
              display: true,
              labelString: "Timestamp",
            },
          },
        ],
      },
    },
    chart: false,
    sumValHumid: "",
    backgroundColor: [
      "rgba(255, 99, 132, 0.2)",
      "rgba(54, 162, 235, 0.2)",
      "rgba(255, 206, 86, 0.2)",
      "rgba(75, 192, 192, 0.2)",
      "rgba(153, 102, 255, 0.2)",
      "rgba(255, 159, 64, 0.2)",
      "rgba(255, 99, 132, 0.2)",
      "rgba(54, 162, 235, 0.2)",
      "rgba(255, 206, 86, 0.2)",
      "rgba(75, 192, 192, 0.2)",
      "rgba(153, 102, 255, 0.2)",
      "rgba(255, 159, 64, 0.2)",
    ],
    borderColor: [
      "rgba(255,99,132,1)",
      "rgba(54, 162, 235, 1)",
      "rgba(255, 206, 86, 1)",
      "rgba(75, 192, 192, 1)",
      "rgba(153, 102, 255, 1)",
      "rgba(255, 159, 64, 1)",
      "rgba(255,99,132,1)",
      "rgba(54, 162, 235, 1)",
      "rgba(255, 206, 86, 1)",
      "rgba(75, 192, 192, 1)",
      "rgba(153, 102, 255, 1)",
      "rgba(255, 159, 64, 1)",
    ],
    sumValTemp: "",
    avgValTemp: "",
    avgValHumid: "",
    chartData: {
      datasets: [
        {
          data: [],
          label: "TemperatureChiller",
          type: "line",
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(172, 0, 252,.9)",
        },
        {
          label: "HumidityChiller",
          type: "line",
          data: [],
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderColor: "rgba(20, 153, 242,.9)",
          borderWidth: 1.5,
        },
      ],
      labels: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "bottom",
      },
      scales: {
        yAxes: [
          {
            id: "A",
            ticks: {
              beginAtZero: true,
              // fontColor: "#ffffff",
            },
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "Temp (C) / Humid ()",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              // fontColor: "#ffffff",
            },
            scaleLabel: {
              display: true,
              labelString: "Timestamp",
            },
          },
        ],
      },
    },
    newArray1: [],
    newArray2: [],
    dateTime: [],
    select: [],
    sdata: [],
    select1: [],
    arrSensor: [],
    // chartData: null,
    arrSensorName: "Chiller",
    data: [],
    header: [
      "Sensor Name",
      "Mac Address",
      "Temperature",
      "Humidity",
      "Battery",
    ],
    a: [2, 3],
    c: 10,
    branch_code: "",
    fontsize: "",
    datachart1: [30, 15, 51, 50, 60, 67, 66],
    datachart2: [20, 12, 26, 32, 30, 9, 32],
    labelInput: ["8 PM", "9 PM", "10 PM", "11 PM", "12 Pm", "1 AM", "2 AM"],
    interval: null,
    data_chart: [],
    max_freezer: 0,
    min_freezer: 0,
    avg_freezer: 0,
    max_chiller: 0,
    min_chiller: 0,
    avg_chiller: 0,
  }),
  async mounted() {
    //  this.$API.get("indoorsensor/"+this.data.gatewayMAC ).then((result) => {
    //     this.data_gateway = result.data;
    //  })

    // this.$API.get(`indoorsensorlog/${this.data.chiller}`).then((result) => {
    //   console.log(result.data);
    // });
    this.$vs.loading();
    this.getDataTemp();
    // this.generateData();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    closeModal() {
      this.$refs["settingChart"].hide();
    },
    async getDataTemp() {
      this.data_gateway = [];
      this.data_chiller = [];
      this.date_chiller = [];
      this.time_chiller = [];
      this.data_freezer = [];
      this.date_freezer = [];
      this.time_freezer = [];
      this.sdata = [];

      try {
        var queryId = this.$route.query.locid;
        this.data = this.$session.get("data");
        this.branch_code = this.$session.get("branch_code");
        //call data
        this.data_sensor = await this.$API.get(`indoorsensor`);
        this.data_sensor = this.data_sensor.data;
        this.filterdata(this.data_sensor);
        //call graph
        this.data_chart = await this.$API.get(`indoorsensorlog/${this.data.chiller}`);
        this.data_chart = this.data_chart.data;
        this.generateData(this.data_chart);
        // console.log(
        //   [this.data.chiller],
        //   this.$moment().subtract(24, "hours").format("YYYY-MM-DDTHH:mm:ss") +
        //   ".000Z"
        // );
        let res_chiller = await this.$API.post(`indoorsensorgraph/multiple`, {
          sensorlist: [this.data.chiller],
          start:
            this.$moment().subtract(24, "hours").format("YYYY-MM-DDTHH:mm:ss") +
            ".000Z",
          end: this.$moment().format("YYYY-MM-DDTHH:mm:ss") + ".000Z",
        });
        // console.log(res_chiller.data[0][0].sensordata.temperature);
        let max_c = res_chiller.data[0][0].sensordata.temperature;
        let min_c = res_chiller.data[0][0].sensordata.temperature;
        let sum_c = 0;
        for (let i = 0; i < res_chiller.data[0].length; i++) {
          const el = res_chiller.data[0][i];
          sum_c += Number(el.sensordata.temperature);
          max_c =
            max_c > Number(el.sensordata.temperature)
              ? max_c
              : Number(el.sensordata.temperature);
          min_c =
            min_c < Number(el.sensordata.temperature)
              ? min_c
              : Number(el.sensordata.temperature);
        }
        this.max_chiller = max_c;
        this.min_chiller = min_c;
        this.avg_chiller = sum_c / res_chiller.data.length;
        // console.log(this.max_chiller);

        let res_freezer = await this.$API.post(`indoorsensorgraph/multiple`, {
          sensorlist: [this.data.freezer],
          start:
            this.$moment().subtract(24, "hours").format("YYYY-MM-DDTHH:mm:ss") +
            ".000Z",
          end: this.$moment().format("YYYY-MM-DDTHH:mm:ss") + ".000Z",
        });
        let max_f = res_freezer.data[0][0].sensordata.temperature;
        let min_f = res_freezer.data[0][0].sensordata.temperature;
        let sum_f = 0;
        for (let i = 0; i < res_freezer.data[0].length; i++) {
          const el = res_freezer.data[0][i];
          sum_f += Number(el.sensordata.temperature);
          max_f =
            max_f > Number(el.sensordata.temperature)
              ? max_f
              : Number(el.sensordata.temperature);
          min_f =
            min_f < Number(el.sensordata.temperature)
              ? min_f
              : Number(el.sensordata.temperature);
        }
        this.max_freezer = max_f;
        this.min_freezer = min_f;
        this.avg_freezer = sum_f / res_freezer.data.length;
        console.log(res_freezer);
        $vs.notify({
          title: "Success",
          position: "top-center",
          color: "primary",
        });
      } catch (error) {
        console.log(error);
        // this.$vs.notify({
        //   title: "Error",
        //   color: "danger",
        //   position: "top-center",
        // });
      }
      this.$vs.loading.close();
      this.interval = setTimeout(() => {
        this.getDataTemp();
      }, 1000 * 120);
    },
    filterdata(data) {
      data.forEach((element) => {
        if (element.mac == this.data.chiller) {
          this.data_gateway.push(element);
          this.data_chiller.push(element);
          this.sdata.push({ text: "Chiller", value: element.mac });
          this.date_chiller.push(
            this.$moment(element.lastdate).format("DD/MM/YYYY")
          );
          this.time_chiller.push(
            this.$moment(element.lastdate).format("hh:mm A")
          );
        } else if (element.mac == this.data.freezer) {
          this.data_freezer.push(element);
          this.data_gateway.push(element);
          this.sdata.push({ text: "Freezer", value: element.mac });
          this.date_freezer.push(
            this.$moment(element.lastdate).format("DD/MM/YYYY")
          );
          this.time_freezer.push(
            this.$moment(element.lastdate).format("hh:mm A")
          );
        }
      });
    },
    // onExport
    onExport() {
      let dataPriority = "";
      // this.dataList.forEach((element) => {
      //   if (element.priority == "1 - Low priority") {
      //     this.dataPriority = "1-Low";
      //   } else if (element.priority == "2 - Medium priority") {
      //     this.dataPriority = "2-Medium";
      //   } else if (element.priority == "3 - High priority") {
      //     this.dataPriority = "3-High";
      //   } else {
      //     this.dataPriority = "-";
      //   }
      //   this.dataExport.push({
      //     work_id: element.id,
      //     priority: this.dataPriority,
      //     work_order: element.name,
      //     asset: element.asset,
      //     name: element.username,
      //     email: element.email,
      //     start_date: element.plandate,
      //     actual_start_date: element.startdate,
      //     end_date: element.duedate,
      //     actual_end_date: element.finishtime,
      //     status: element.iscomplete,
      //     response: element.response,
      //     detail: element.detail,
      //   });
      // });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.data.branch_eng + "TimeSeries.xlsx");
      this.dataExport = [];
    },
    exportToPDF() {
      let pdfRef = this.$refs.pdf;
      html2canvas(pdfRef).then((canvas) => {
        let pdfImage = canvas.toDataURL();
        let pdf = new jsPDF();
        pdf.addImage(pdfImage, "PNG", 0, 20, 200, 50);
        pdf.save("Chart_TimeSeries.pdf");
      });
    },
    getRandomColor() {
      var color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
      // var color2 = "hsl(" + Math.random() * 360 + ", 100%, 75%,.1)";
      // var color = [color1, color2];
      // console.log(color);
      return color;
    },
    getChartData() {
      var array1 = [];
      var array2 = [];
      var dateTimelabel = [];
      var nameArrs = "";
      var dataset = [];
      var index = 0;
      var length1 = 0;
      var length2 = 0;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      var sumArray1 = 0;
      var sumArray2 = 0;
      this.newArray1 = [];
      var dataMac = [];
      var dataNameLabel = [];
      this.dataExport = [];
      var randomColor = this.getRandomColor();
      this.newArray2 = [];
      this.dateTime = [];
      console.log(this.arrSensor);
      this.arrSensorName = "";
      this.arrSensor.forEach((x) => {
        dataMac.push(x.value);
        dataNameLabel.push(x.text);
        console.log(x.text);
        nameArrs += x.text + " ";
      });
      console.log(dataMac);
      this.$API
        .post("indoorsensorgraph/multiple", {
          sensorlist: dataMac,
          start: this.mintime,
          end: this.maxtime,
        })
        .then((result) => {
          console.log(result.data);
          console.log(this.mintime);
          console.log(this.maxtime);

          result.data.forEach((element) => {
            array1[index] = [];
            array2[index] = [];
            for (var i = 0; i < element.length; i++) {
              let obj = element[i];
              // console.log(obj);
              array1[index].push(obj.sensordata.temperature);
              array2[index].push(obj.sensordata.humidity);
              if (index == 0) {
                dateTimelabel.push(
                  this.$moment(obj.timestamp).format("DD/MM/YY hh:mmA")
                );
              }
              this.dataExport.push({
                Timestamp: this.$moment(obj.timestamp).format(
                  "DD/MM/YYYY hh:mm a"
                ),
                Name: obj.name,
                Mac: obj.mac,
                Temperature: obj.sensordata.temperature,
                Humidity: obj.sensordata.humidity,
              });
            }
            index++;
            this.maxValTemp = Math.max.apply(Math, array1);
            this.minValTemp = Math.min.apply(Math, array1);
            this.maxValHumid = Math.max.apply(Math, array2);
            this.minValHumid = Math.min.apply(Math, array2);
            console.log(array1);
            for (var i = 0; i < array1.length; i++) {
              this.sumValTemp += array1[i];
            }
            this.avgValTemp = this.sumValTemp / array1.length;
            for (var i = 0; i < array2.length; i++) {
              this.sumValHumid += array2[i];
            }
            this.avgValHumid = this.sumValHumid / array2.length;
            console.log(this.avgValTemp.toFixed(2));
            console.log(this.avgValHumid.toFixed(2));
            this.$refs["settingChart"].hide();
            this.arrSensorName = nameArrs;
          });
          // console.log(array1);
          array1.forEach((element, i) => {
            dataset.push(
              {
                label: "Temperature" + dataNameLabel[i],
                type: "line",
                data: array1[i],
                borderColor: this.borderColor[i],
                backgroundColor: this.backgroundColor[i],
                borderWidth: 1.5,
              },
              {
                label: "Humidity" + dataNameLabel[i],
                type: "line",
                data: array2[i],
                borderColor: this.borderColor[i + 2],
                backgroundColor: this.backgroundColor[i + 2],
                borderWidth: 1.5,
              }
            );

            sumArray1 += element.reduce((a, b) => a + b, 0);
            length1 += element.length;

            sumArray2 += array2[i].reduce((a, b) => a + b, 0);
            length2 += array2[i].length;

            this.maxValTemp = Math.max.apply(Math, array1[i]);
            this.minValTemp = Math.min.apply(Math, array1[i]);
            this.maxValHumid = Math.max.apply(Math, array2[i]);
            this.minValHumid = Math.min.apply(Math, array2[i]);
          });

          this.avgValTemp = sumArray1 / length1;
          this.avgValHumid = sumArray2 / length2;
          console.log(sumArray1, length1, sumArray1 / length1);
          console.log(sumArray2, length2, sumArray2 / length2);
          console.log(this.maxValTemp);
          console.log(this.minValTemp);
          console.log(this.maxValHumid);
          console.log(this.minValHumid);
          this.chart_Data_inside.labels = dateTimelabel;
          this.chart_Data_inside.datasets = dataset;
          // this.chart_Data_inside.datasets[1].data = this.newArray2;

          // this.chartData = {
          //   labels: dateTimelabel,
          //   datasets: dataset,
          // };
          // this.options = {
          //   responsive: true,
          //   maintainAspectRatio: false,
          //   legend: {
          //     position: "bottom",
          //   },
          //   scales: {
          //     yAxes: [
          //       {
          //         id: "A",
          //         ticks: {
          //           beginAtZero: true,
          //           // fontColor: "#ffffff",
          //         },
          //         position: "left",
          //         scaleLabel: {
          //           display: true,
          //           labelString: "Temp (C) / Humid (%)",
          //         },
          //       },
          //     ],
          //     xAxes: [
          //       {
          //         ticks: {
          //           beginAtZero: true,
          //           // fontColor: "#ffffff",
          //         },
          //         scaleLabel: {
          //           display: true,
          //           labelString: "Timestamp",
          //         },
          //       },
          //     ],
          //   },
          // };
        });
    },
    generateData(data) {
      this.chart = false;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      this.newArray1 = [];
      this.dataExport = [];
      this.newArray2 = [];
      this.dateTime = [];
      // await this.$API
      //   .get(`indoorsensorlog/${this.data.chiller}`)
      //   .then((result) => {
      // console.log(result.data);
      
      for (var i = 0; i < data.length; i++) {
        let obj = data[i];
        this.newArray1.push(obj.sensordata.temperature);
        this.newArray2.push(obj.sensordata.humidity);
        this.dateTime.push(
          this.$moment(obj.timestamp).format("DD/MM/YYYY hh:mm a")
        );
        this.dataExport.push({
          Timestamp: this.$moment(obj.timestamp).format("DD/MM/YYYY hh:mm a"),
          Name: obj.name,
          Mac: obj.mac,
          Temperature: obj.sensordata.temperature,
          Humidity: obj.sensordata.humidity,
        });
      }
      this.maxValTemp = Math.max.apply(Math, this.newArray1);
      this.minValTemp = Math.min.apply(Math, this.newArray1);
      this.maxValHumid = Math.max.apply(Math, this.newArray2);
      this.minValHumid = Math.min.apply(Math, this.newArray2);
      for (var i = 0; i < this.newArray1.length; i++) {
        this.sumValTemp += this.newArray1[i];
      }
      this.avgValTemp = this.sumValTemp / this.newArray1.length;
      for (var i = 0; i < this.newArray2.length; i++) {
        this.sumValHumid += this.newArray2[i];
      }
      this.avgValHumid = this.sumValHumid / this.newArray2.length;
      // });
      this.chart_Data_inside.labels = this.dateTime;
      this.chart_Data_inside.datasets[0].data = this.newArray1;
      this.chart_Data_inside.datasets[1].data = this.newArray2;

      this.chartData = {
        labels: this.dateTime,
        datasets: [
          {
            label: "TemperatureChiller",
            type: "line",
            data: this.newArray1,
            backgroundColor: "rgba(172, 0, 252,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "HumidityChiller",
            type: "line",
            data: this.newArray2,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderColor: "rgba(20, 153, 242,.9)",
            borderWidth: 1.5,
          },
        ],
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                // fontColor: "#ffffff",
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temp (C) / Humid ()",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                // fontColor: "#ffffff",
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
      setTimeout(() => {
        this.chart = true;
      }, 1000);
    },
  },
  created() {
    // console.log(this.branch_code);

    //  this.generateData();
    // if ((this.branch_code = "00001")) {
    //   console.log("Yessssssssssssssssssssssss");
    //   this.$API.get("indoorgateway/" + this.data.gatewayMAC).then((result) => {
    //     this.data_sensor = result.data;
    //     // console.log(result);
    //   });
    // } else {
    //   console.log("Nooooooooooooooooo");
    // }

    if (window.innerWidth < 1550) {
      this.fontsize = 15;
    }
    // else if (window.innerWidth > 1550) {
    //   this.fontsize = 25;
    // }
    else if (window.innerWidth > 1550) {
      this.fontsize = 25;
    }
  },
};
</script>

<style scoped>
@font-face {
  font-family: "7 Segment";
  src: local("7 Segment"),
    url("./../../../../../src/assets/Font/7-Segment-Font/Seven Segment.ttf") format("truetype");
}

.listS {
  list-style-type: none;
}

.fontBetagro {
  color: #32c040;
  font-size: 15px;
}

.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}

#id2 {
  width: 230px;
  /* padding: 0;
  margin: 0; */
  border-radius: 20px;
  margin-bottom: 0px;
}

.cardBorder {
  border-radius: 20px;
}

.listnone {
  list-style: none;
}

#text1 {
  font-weight: 550;
}

#text2 {
  /* color: grey; */
  font-size: 85%;
}

#text3 {
  /* color: grey; */
  font-size: 85%;
}

#text4 {
  color: #ffde3d;
  font-size: 32px;
  font-weight: 550;
}

#text5 {
  font-weight: 550;
}

#text6 {
  color: #2ba0ff;
  font-size: 32px;
  font-weight: 550;
}

#text7 {
  font-weight: 550;
}
</style>

<style lang="scss" scoped>
.bottom-right-surface-graph {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.box-chart {
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: 0;
  }
}

.avg {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #ffa807;
}

.min {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #f707ff;
}

.max {
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #8f07ff;
}
</style>
